<script>
    import HomePageTimeConfirmations from './HomePageTimeConfirmations.svelte';

    export let branch;
    export let branchId;

</script>

<HomePageTimeConfirmations {branch} {branchId} execution={true}/>